import Instance from "../../../../Axios";

// New Actions for the app

const GetMediaDiasRespostaCredEstados = () => async (dispatch) => {
  await Instance()
    .get(`/credenciacoes/mediaDiasRespostaCredEstados`)
    .then(({ data }) => {
      dispatch({
        type: "GET_MEDIA_DIAS_RESPOSTA_CRED_ESTADOS",
        payload: data.yData,
      });
    })
    .catch((err) => {
      console.log(err);
    });
};

export default GetMediaDiasRespostaCredEstados;